/**
 * FauxDS AccordionGroup
 *
 * ⚠️ This is a SIMPLIFIED RECREATION of the Slate AccordionGroup component for prototyping.
 * It is NOT the real @faire/slate AccordionGroup and should NOT be used for:
 * - Engineering handoff
 * - Design specs
 * - Production code
 *
 * For the real Slate AccordionGroup, see: @faire/slate/components/accordion
 *
 * Note: AccordionItem has been migrated to AccordionItem.
 * This file only exports AccordionGroup which is still used.
 */
import { cn } from "@faire/prototype-playground/lib/utils";
import React from "react";

export interface AccordionGroupProps {
  /**
   * The accordion items
   */
  children: React.ReactNode;

  /**
   * **playground only**
   * Optional className for additional styling
   */
  className?: string;
}

/**
 * AccordionGroup - FauxDS (recreated from Slate)
 *
 * A container for accordion items.
 * This is a simplified implementation for prototyping purposes.
 */
export function AccordionGroup({
  children,
  className = "",
}: AccordionGroupProps) {
  return (
    <div
      className={cn(
        "border-t border-[var(--slate-color-border-muted)]",
        className
      )}
    >
      {children}
    </div>
  );
}
